/**
 * The email shape `react-jhipster`'s `isEmail` accepted, kept verbatim so the backoffice forms reject and
 * accept exactly the same strings they did before that package was removed.
 */
const EMAIL_REGEXP =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

/**
 * Whether `value` looks like an email address.
 *
 * <p><b>An empty value passes.</b> That is not an oversight — it is the contract the call sites rely on:
 * every one of them pairs this with a separate `required` rule, and "is it required" and "is it well
 * formed" are different questions. Returning `false` for an empty field would show "email inválido" on a
 * form the user has not filled in yet, on top of the required error.
 */
export const isEmail = (value?: string | null): boolean => {
  if (value === undefined || value === null || value === '') return true;
  return EMAIL_REGEXP.test(value);
};
